import { useOnboardingStore } from '../../../store/onboardingStore'
import { useCallback, useEffect, useState } from 'react'
import { profileApi } from '../../../api/profile'
import { useAuthStore } from '../../../store/authStore'
import { isSegmentId, type SegmentId } from './types'

export interface AccountProduct { userId: string; segment: SegmentId; onboarded: boolean }
export function useAccountSegment() {
  const userId = useAuthStore((s) => s.userId)
  const generation = useAuthStore((s) => s.sessionGeneration)
  const authenticated = useAuthStore((s) => s.isAuthenticated())
  const [result, setResult] = useState<{ owner: string; generation: number; profile?: AccountProduct; error?: string } | null>(null)
  const [revision, setRevision] = useState(0)
  const retry = useCallback(() => { setResult(null); setRevision((n) => n + 1) }, [])
  useEffect(() => {
    if (!authenticated || !userId) return
    let active = true
    profileApi.get().then((raw) => {
      const profile = raw as { user_id?: string; segment?: unknown; onboarded?: boolean; display_name?: string }
      const segment = profile.segment === undefined ? 'humanteq' : profile.segment
      if (!isSegmentId(segment) || profile.user_id !== userId) throw new Error('Не удалось определить продукт аккаунта')
      if (!active) return
      if (profile.display_name) useAuthStore.getState().setDisplayName(profile.display_name)
      useOnboardingStore.getState().setOnboarded(Boolean(profile.onboarded), userId)
      setResult({ owner: userId, generation, profile: { userId, segment, onboarded: Boolean(profile.onboarded) } })
    }).catch(() => {
      if (active) setResult({ owner: userId, generation, error: 'Не удалось загрузить профиль. Попробуйте ещё раз.' })
    })
    return () => { active = false }
  }, [authenticated, userId, generation, revision])
  const current = result?.owner === userId && result?.generation === generation ? result : null
  return { authenticated, profile: authenticated ? current?.profile : undefined, error: current?.error, retry }
}
